export default function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}


//////////////////
// WEBPACK FOOTER
// ../@popperjs/core/lib/utils/getFreshSideObject.js
// module id = 806
// module chunks = 22